import { Center, HTMLChakraProps } from '@chakra-ui/react';
import { ReactNode } from 'react';

type Props = {
  children: ReactNode;
  onClick?: () => void;
} & HTMLChakraProps<'div'>;

export default function PopupContainer({ children, onClick, ...props }: Readonly<Props>) {
  return (
    <Center
      width="100%"
      height="max-content"
      backgroundColor="neutral.700"
      padding="standardM"
      cursor={onClick ? 'pointer' : 'default'}
      onClick={onClick}
      {...props}
    >
      {children}
    </Center>
  );
}
